import VideoPlayerBack from './VideoPlayerBack'

export default VideoPlayerBack
// eslint-disable-next-line import/export
export * from './VideoPlayerBack'
